<template>
  <b-modal
    ref="modalImageLibrary"
    title="Choose from library"
    size="xl"
    centered
    v-on:ok="confirm"
    cancel-variant="white"
    ok-variant="yellow"
    :ok-disabled="disabled"
    scrollable
    v-on:hidden="cancel"
  >
    <b-tabs v-model="tabIndex">
      <b-tab v-for="(tab, tabIndex) in tabs" :title="tab" :key="tabIndex" />
    </b-tabs>
    <b-row>
      <b-col>
        <b-row
          v-for="(chunk, chunkIndex) in filteredImageChunks"
          :key="'row-' + chunkIndex"
          no-gutters
        >
          <b-col v-for="image in chunk" :key="image.id" style="flex-grow: 0">
            <div style="padding: 1px" :id="`popover-1-${image.id}`">
              <img
                @click="selectImage(chunkIndex, image)"
                :src="getImage(image, true)"
                width="115px"
                :class="
                  selectedImage && selectedImage.id === image.id
                    ? 'border border-primary p-3'
                    : ''
                "
              />
            </div>
          </b-col>
        </b-row>
      </b-col>
      <b-col v-if="selectedImage" cols="8">
        <div class="d-flex">
          <b-button @click="navigateImage(-1)">
            <b-icon-chevron-left />
          </b-button>
          <div>
            <b-img :src="fullImage" fluid />
          </div>
          <b-button @click="navigateImage(1)">
            <b-icon-chevron-right />
          </b-button>
        </div>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import { imageService } from '../../services/image.service.js'
import { BIconChevronLeft, BIconChevronRight } from 'bootstrap-vue'
import ImageMixin from '../../mixins/ImageMixin'
import _ from 'lodash'

export default {
  name: 'ImageLibraryModal',
  components: {
    BIconChevronLeft,
    BIconChevronRight
  },
  mixins: [ImageMixin],
  data() {
    return {
      selectedImage: null,
      selectedChunkIndex: null,
      disabled: true,
      images: [],
      tabIndex: 0
    }
  },
  computed: {
    tabs() {
      return [
        'All Bonacube pics',
        'Space',
        'Stuff',
        'Staff',
        'Service',
        'Event',
        'Storyboard',
        'Stage',
        'Step',
        'Random'
      ]
    },
    filteredImageChunks() {
      let images = this.images
      if (this.tabIndex > 0) {
        images = this.images.filter(
          (image) => image.tag === this.tabs[this.tabIndex].toLowerCase()
        )
      }
      images = images.reduce((all, one, i) => {
        const ch = Math.floor(i / 9)
        all[ch] = [].concat(all[ch] || [], one)
        return all
      }, [])
      return images
    },
    fullImage() {
      return this.getImage(this.selectedImage)
    }
  },
  methods: {
    selectImage(chunkIndex, image) {
      this.disabled = false
      this.selectedImage = image
      this.selectedChunkIndex = chunkIndex
    },
    confirm() {
      this.$parent.$parent.$refs.imageDropzone.removeAllFiles()
      this.$parent.$parent.imageId = this.selectedImage.id

      let mockFile = {
        id: this.$parent.$parent.imageId,
        size: 175,
        url: this.getImage(this.selectedImage)
      }
      this.$parent.$parent.$refs.imageDropzone.manuallyAddFile(
        mockFile,
        mockFile.url
      )
      this.selectedImage = null
    },
    cancel() {
      this.selectedImage = null
      this.selectedChunkIndex = null
    },
    navigateImage(indexChange) {
      const allImages = this.filteredImageChunks.flat()
      let imageIndex = allImages.findIndex(
        (image) => image.id === this.selectedImage.id
      )
      imageIndex += indexChange

      if (imageIndex > allImages.length || imageIndex < 0) {
        return
      }
      const image = allImages[imageIndex]

      if (image) {
        this.selectImage(this.selectedChunkIndex, image)
      }
    }
  },
  mounted() {
    imageService.getLibraryImages(true).then((images) => {
      this.images = _.sortBy(images, [function(i) { return i.imageFd.toLowerCase(); }]);
    })
  }
}
</script>
